<div class="max-page-width">

  <div class="row m-0 confirmation" >

    <div class="col-lg-1 col-md-12"></div>
    <div class="col-lg-10 col-md-12 mt-4">


      <div class="confirmation-container" *ngIf="reservationCaseResult!=null">
        <div class="title text-center">
          <h1>{{ 'FailurePayment' | translate }}</h1>
          <small> {{ 'YourBookingIsCanceld' | translate }}</small>
        </div>

        <div class="car-confirmed">
          <div class="row">
            <div class="col-lg-8 col-md-7">

              <div class="row">
                <div class="col-md-5">


                </div>


                </div>
              </div>

            </div>
            <div class="col-lg-4 col-md-4 booked-car-amount">
              <div>
                <div class="booking-pickup-dropoff">{{ 'BookingNo' | translate }} </div>
                <div class="booked-car-namber">{{reservationCaseResult.bookingNumberFormatted}}</div>
              </div>
              <div class="booked-car-total mt-4">
                <div class="text-blue total-text">{{ 'TotalCharges' | translate }}</div>
                <div class="total-num">{{reservationCaseResult.grandTotal | number}} {{currency}}</div>
              </div>
              <div class="booked-car-total">
                <div class="text-blue total-text">{{ 'PaidAmount' | translate }}</div>
                <div class="total-num">{{reservationCaseResult.paid  | number}} {{currency}}</div>
              </div>
              <div class="booked-car-total ">
                <div class="text-blue total-text">{{ 'ContactInformation' | translate }}</div>
                <div class="contact-text">
                  {{reservationCaseResult.fromAgencyName}}<br />
                  {{reservationCaseResult.fromAgencyPhone}}<br />
                  {{reservationCaseResult.fromAgencyEmail}}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>



    </div>
    <div class="col-lg-1 col-md-12"></div>




  </div>




